module.exports = __webpack_public_path__ + "img/listshore.4cb7b17f.png";